import { cva, type VariantProps } from "cva";

export const iconButtonStyles = cva({
  base: [
    "relative overflow-hidden flex items-center justify-center font-ginto font-normal leading-100 transition-colors duration-250 ease-out-quad [&>svg]:fill-current [&>svg]:z-2",
  ],
  variants: {
    variant: {
      soft: "bg-ink-100 dark:bg-chalk-200 text-content-primary dark:text-content-light",
      solid:
        "bg-surface text-content-primary dark:text-content-light before:content-[''] before:absolute before:inset-0 before:bg-surface before:z-0 before:bg-transparent before:transition-colors before:duration-250 before:ease-out-quad",
      stroke:
        "bg-surface text-content-primary dark:text-content-light border-1 border-border-decorative before:absolute before:inset-0 before:bg-surface before:z-0 before:bg-transparent before:transition-colors before:duration-250 before:ease-out-quad",
      transparent: "bg-transparent text-current",
      media: "bg-ink-500 text-content-light backdrop-blur-button",
    },
    size: {
      xs: "w-32 h-32 rounded-xs",
      s: "w-40 h-40 rounded-sm",
      m: "w-48 h-48 rounded-md",
      l: "w-56 h-56 rounded-lg",
    },
    disabled: {
      true: "cursor-default opacity-50",
      false: "cursor-pointer ",
    },
  },
  compoundVariants: [
    {
      variant: "soft",
      disabled: false,
      class: "hover:bg-ink-200 active:bg-ink-200 dark:hover:bg-chalk-300 dark:active:bg-chalk-300",
    },
    {
      variant: "solid",
      disabled: false,
      class:
        "hover:before:bg-ink-100 active:before:bg-ink-100 dark:hover:before:bg-chalk-200 dark:active:before:bg-chalk-200",
    },
    {
      variant: "stroke",
      disabled: false,
      class: "hover:before:bg-ink-100 dark:hover:before:bg-chalk-200",
    },
    {
      variant: "transparent",
      disabled: false,
      class: "hover:bg-ink-200 active:bg-ink-200 dark:hover:bg-chalk-300 dark:active:bg-chalk-300",
    },
    {
      variant: "media",
      disabled: false,
      class: "hover:bg-ink-600 active:bg-ink-500 dark:hover:bg-chalk-600 dark:active:bg-chalk-500",
    },
    {
      size: ["xs", "s"],
      class: "[&>svg]:w-18 [&>svg]:h-18",
    },
    {
      size: ["m", "l"],
      class: "[&>svg]:w-24 [&>svg]:h-24",
    },
  ],
});

export type IconButtonStylesProps = VariantProps<typeof iconButtonStyles>;
